import {
  PopupActionTypes,
  IOpenExternalTokenPopupPayload,
  IOpenProjectSharingPopupPayload,
  IOpenImportSrtPopupPayload,
  IOpenDeleteProjectPopupPayload,
  IOpenRenameLabelPopupPayload,
  IOpenDeleteLabelPopupPayload,
  IOpenSetupProjectPopupPayload,
  IOpenSetupProjectPopupTtsPayload,
  IOpenDeleteWorkspacePopupPayload,
  IOpenRemoveSpeakerVoicePopupPayload,
  IOpenVoiceTypeUpgradePopupPayload,
  IOpenDeleteProjectVersionPopupPayload,
  IOpenRenameProjectPopupPayload,
  IOpenRenameProjectVersionPopupPayload,
  IOpenExportationPopupPayload,
  ISetEditingProjectIdsPayload,
} from './types'

export const closeDashboardPopups = () => ({
  type: PopupActionTypes.CLOSE_DASHBOARD_POPUPS
})

export const closeLabelPopups = () => ({
  type: PopupActionTypes.CLOSE_LABEL_POPUPS
})

export const closeVoiceStudioPopups = () => ({
  type: PopupActionTypes.CLOSE_VOICE_STUDIO_POPUPS
})

export const openCreateLabelPopup = () => ({
  type: PopupActionTypes.OPEN_CREATE_LABEL_POPUP
})

export const openDeleteLabelPopup = (payload: IOpenRenameLabelPopupPayload) => ({
  type: PopupActionTypes.OPEN_DELETE_LABEL_POPUP,
  payload,
})

export const openRenameLabelPopup = (payload: IOpenDeleteLabelPopupPayload) => ({
  type: PopupActionTypes.OPEN_RENAME_LABEL_POPUP,
  payload,
})

export const openExternalTokenPopup = (payload: IOpenExternalTokenPopupPayload) => ({
  type: PopupActionTypes.OPEN_EXTERNAL_TOKEN_POPUP,
  payload
})

export const openProjectSharingPopup = (payload: IOpenProjectSharingPopupPayload) => ({
  type: PopupActionTypes.OPEN_PROJECT_SHARING_POPUP,
  payload
})

export const openImportSrtPopup = (payload: IOpenImportSrtPopupPayload) => ({
  type: PopupActionTypes.OPEN_IMPORT_SRT_POPUP,
  payload
})

export const openDeleteProjectPopup = (payload: IOpenDeleteProjectPopupPayload) => ({
  type: PopupActionTypes.OPEN_DELETE_PROJECT_POPUP,
  payload
})

export const openDeleteProjectVersionPopup = (payload: IOpenDeleteProjectVersionPopupPayload) => ({
  type: PopupActionTypes.OPEN_DELETE_PROJECT_VERSION_POPUP,
  payload
})

export const openRenameProjectPopup = (payload: IOpenRenameProjectPopupPayload) => ({
  type: PopupActionTypes.OPEN_RENAME_PROJECT_POPUP,
  payload
})

export const openRenameProjectVersionPopup = (payload: IOpenRenameProjectVersionPopupPayload) => ({
  type: PopupActionTypes.OPEN_RENAME_PROJECT_VERSION_POPUP,
  payload
})

export const openExportationPopup = (payload: IOpenExportationPopupPayload) => ({
  type: PopupActionTypes.OPEN_EXPORTATION_POPUP,
  payload
})

export const openAccountPopup = () => ({
  type: PopupActionTypes.OPEN_ACCOUNT_POPUP,
})

export const closeAccountPopup = () => ({
  type: PopupActionTypes.CLOSE_ACCOUNT_POPUP,
})

export const openNewProjectPopup = () => ({
  type: PopupActionTypes.OPEN_NEW_PROJECT_POPUP,
})

export const openSetupProjectPopup = (payload: IOpenSetupProjectPopupPayload) => ({
  type: PopupActionTypes.OPEN_SETUP_PROJECT_POPUP,
  payload
})

export const closeSetupProjectPopup = () => ({
  type: PopupActionTypes.CLOSE_SETUP_PROJECT_POPUP,
})

export const openSetupProjectPopupTts = (payload: IOpenSetupProjectPopupTtsPayload) => ({
  type: PopupActionTypes.OPEN_SETUP_PROJECT_POPUP_TTS,
  payload
})

export const closeSetupProjectPopupTts = () => ({
  type: PopupActionTypes.CLOSE_SETUP_PROJECT_POPUP_TTS,
})

export const openLabelsManagerPopup = () => ({
  type: PopupActionTypes.OPEN_LABELS_MANAGER_POPUP,
})

export const closeLabelsManagerPopup = () => ({
  type: PopupActionTypes.CLOSE_LABELS_MANAGER_POPUP,
})

export const openNewsletterPopup = () => ({
  type: PopupActionTypes.OPEN_NEWSLETTER_POPUP,
})

export const closeNewsletterPopup = () => ({
  type: PopupActionTypes.CLOSE_NEWSLETTER_POPUP,
})

export const openDeleteWorkspacePopup = (payload: IOpenDeleteWorkspacePopupPayload) => ({
  type: PopupActionTypes.OPEN_DELETE_WORKSPACE_POPUP,
  payload,
})

export const closeDeleteWorkspacePopup = () => ({
  type: PopupActionTypes.CLOSE_DELETE_WORKSPACE_POPUP,
})

export const openCreateWorkspacePopup = () => ({
  type: PopupActionTypes.OPEN_CREATE_WORKSPACE_POPUP,
})

export const closeCreateWorkspacePopup = () => ({
  type: PopupActionTypes.CLOSE_CREATE_WORKSPACE_POPUP,
})

export const openCreateAccountUserPopup = () => ({
  type: PopupActionTypes.OPEN_CREATE_ACCOUNT_USER_POPUP,
})

export const closeCreateAccountUserPopup = () => ({
  type: PopupActionTypes.CLOSE_CREATE_ACCOUNT_USER_POPUP,
})

export const openManageWorkspaceAccessPopup = () => ({
  type: PopupActionTypes.OPEN_MANAGE_WORKSPACE_ACCESS_POPUP,
})

export const closeManageWorkspaceAccessPopup = () => ({
  type: PopupActionTypes.CLOSE_MANAGE_WORKSPACE_ACCESS_POPUP
})

export const openVoiceTypeUpgradePopup = (payload: IOpenVoiceTypeUpgradePopupPayload) => ({
  type: PopupActionTypes.OPEN_VOICE_TYPE_UPGRADE_POPUP,
  payload
})

export const closeVoiceTypeUpgradePopup = () => ({
  type: PopupActionTypes.CLOSE_VOICE_TYPE_UPGRADE_POPUP,
})

export const openRemoveSpeakerVoicePopup = (payload: IOpenRemoveSpeakerVoicePopupPayload) => ({
  type: PopupActionTypes.OPEN_REMOVE_SPEAKER_VOICE_POPUP,
  payload,
})

export const closeRemoveSpeakerVoicePopup = () => ({
  type: PopupActionTypes.CLOSE_REMOVE_SPEAKER_VOICE_POPUP,
})

export const openImportTermsPopup = () => ({
  type: PopupActionTypes.OPEN_IMPORT_TERMS_POPUP,
})

export const closeImportTermsPopup = () => ({
  type: PopupActionTypes.CLOSE_IMPORT_TERMS_POPUP,
})

export const openMoveToOtherWorkspacePopup = () => ({
  type: PopupActionTypes.OPEN_MOVE_TO_OTHER_WORKSPACE_POPUP,
})

export const closeMoveToOtherWorkspacePopup = () => ({
  type: PopupActionTypes.CLOSE_MOVE_TO_OTHER_WORKSPACE_POPUP,
})

export const openRenewSubscriptionPopup = () => ({
  type: PopupActionTypes.OPEN_RENEW_SUBSCRIPTION_POPUP,
})

export const closeRenewSubscriptionPopup = () => ({
  type: PopupActionTypes.CLOSE_RENEW_SUBSCRIPTION_POPUP,
})

export const setEditingProjectIds = (payload: ISetEditingProjectIdsPayload) => ({
  type: PopupActionTypes.SET_EDITING_PROJECT_IDS,
  payload,
})
